module.exports = {
  EXPERIMENT_ENTITY_ID: 'ECEI',
  LAST_DISCARDED_NOTIFICATION: 'lastDiscardedNotification',
  LAST_READ_NOTIFICATION: 'lastReadNotificationTimestamp',
  MAIN: 'ECFG',
  HEIMDALL: 'ECHA',
  USER_IMPACT: 'ECHA',
  LOGIN_BETA: 'ECBT',
  TYPETAG_LEGACY: '__tt',
  HEADER_INSTALL_CTA_DISMISSED: 'serpCtaDismiss',
  SEARCHES_AFTER_INSTALL: 'ECSAI',
  CONSENT: 'ECCC',
  ECOSIA_EXPERIMENT_DATA: 'ECED',
  REQUEST_ID: 'ECRQ',
  APP_SNOWPLOW_ID: 'app_sp',
  UNLEASH: 'ECUNL',
};
